import React, { Component } from "react";
// styles
import "./normalButton.scss";
import ClipLoader from "react-spinners/ClipLoader";
// services
import { height } from "@material-ui/system";

export class NormalButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  handleClick = async () => {
    const { onClick, isLoadable } = this.props;
    const { isLoading } = this.state;

    // Prevent double-clicks while already loading
    if (isLoading) return;

    if (isLoadable) {
      this.setState({ isLoading: true });
      try {
        if (onClick) {
          await onClick();
        }
      } catch (e) {
        console.log("Button onClick error:", e);
      } finally {
        this.setState({ isLoading: false });
      }
    } else {
      if (onClick) {
        onClick();
      }
    }
  };
  

  render() {
    const {
      className = "",
      label = "",
      onClick,
      id,
      orderBtn,
      primaryBtn,
      approveBtn,
      denyBtn,
      verifyBtn,
      verifiedBtn,
      undoBtn,
      rejectBtn,
      correctionBtn,
      printBtn,
      loginOutline,
      type = "submit",
      disabled = false,
      cancelBtn = false,
      isLoadable=false,
      loading=false
    } = this.props;
    
    const { isLoading } = this.state;
    return (
      <div>
        <button
          id={id}
          type={type}
          className={`cursor-pointer 
                     ${cancelBtn ? "cancelBtn" : ""}
                     ${primaryBtn ? "primaryBtn " : ""}
                     ${orderBtn ? "orderBtn" : ""}
                     ${approveBtn ? "approveBtn" : ""}
                     ${denyBtn ? "denyBtn" : ""}
                     ${verifyBtn ? "verifyBtn" : ""}
                     ${undoBtn ? "undoBtn" : ""}
                     ${loginOutline ? "loginOutline" : ""}
                     ${rejectBtn ? "rejectBtn" : ""}
                     ${correctionBtn ? "correctionBtn" : ""}
                     ${verifiedBtn ? "verifiedBtn" : ""}
                     ${printBtn ? "printBtn" : ""}
                     ${className}`}

          onClick={isLoadable ? this.handleClick : onClick}
          disabled={disabled || isLoading}
        >
          {isLoadable && isLoading ? (
         <div className="d-flex align-items-center gap-2">
           <ClipLoader size={15} speedMultiplier={0.8} color={"#fff"} loading={true} />{label}
         </div>
        ) : loading ? (
          <div className="d-flex align-items-center gap-2">
          <ClipLoader size={15} speedMultiplier={1.3} color={"#fff"} loading={true} />{label}
        </div>
        ):(
          <>{label}</>
        )}
        </button>
      </div>
    );
  }
}

export default NormalButton;
